import { Alert } from "antd";
import { toast } from "react-toastify";

import Loading from "@/components/Loading";
import { useUpdateURLSearchParams } from "@/hooks/useQuery";
import useSearchParams from "@/hooks/useSearchParams";
import useDeleteRoleById from "@/queries/profile/roles/useDeleteRoleById";
import { useLoadRoles } from "@/queries/profile/roles/useLoadRoles";
import Modal from "@/ui/Modal";

const DeleteRoleByIdModal = () => {
  const searchParams = useSearchParams();
  const updateParams = useUpdateURLSearchParams();
  const { data: roles, isLoading: isLoadingData } = useLoadRoles();
  const {
    deleteRoleById,
    isLoading: isLoadingDelete,
    isError,
  } = useDeleteRoleById();

  const roleId = Number(searchParams.get("deleteId") || 0);

  const currentRole = roles?.find((item) => item.id === roleId);
  const hasUsersAssigned = currentRole?.has_users_assigned;

  const isLoading = isLoadingData || isLoadingDelete;

  const onConfirm = () => {
    deleteRoleById(roleId)
      .then(() => {
        updateParams(["deleteId", undefined]);
        toast.success("Role deleted");
      })
      .catch((error) => {
        toast.error("Error deleting role");
        throw error;
      });
  };

  return (
    <Modal
      open
      okButtonProps={{
        disabled: isLoading || hasUsersAssigned,
        className: "ml-2",
      }}
      okText="Delete"
      onCancel={() => updateParams(["deleteId", undefined])}
      onOk={() => onConfirm()}
      title="Delete Role"
      width={{
        xs: "90%",
        sm: "80%",
        md: "50%",
        lg: "50%",
        xl: "30%",
        xxl: "30%",
      }}
    >
      {isLoading && <Loading className="!h-48" />}

      {!isLoading && isError && <p>This role doesn't exist.</p>}

      {!isLoading && !isError && currentRole && hasUsersAssigned && (
        <Alert
          showIcon
          className="my-4"
          description="You must reassign all users to a different role before deleting this role."
          message="Users Assigned to This Role"
          type="warning"
        />
      )}

      {!isLoading && !isError && currentRole && !hasUsersAssigned && (
        <p className="text-base my-4">
          Are you sure you want to delete the role{" "}
          <strong>{currentRole?.name}</strong>?
        </p>
      )}
    </Modal>
  );
};

export default DeleteRoleByIdModal;
